import { render, staticRenderFns } from "./keywordRanking.vue?vue&type=template&id=fdf6bb06&scoped=true"
import script from "./keywordRanking.vue?vue&type=script&lang=js"
export * from "./keywordRanking.vue?vue&type=script&lang=js"
import style0 from "./keywordRanking.vue?vue&type=style&index=0&id=fdf6bb06&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdf6bb06",
  null
  
)

export default component.exports